export default class Menu {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.lang = {
            toggler: document.querySelector('#select-language .dropdown-toggler'),
            menu: document.querySelector('#select-language .dropdown-menu'),
        }
    }

    init() {
        this.toggle();
        if(this.lang.toggler){ this.language(); }
    }

    toggle = () => {
        $("#toggle").click(function () {
            $(this).toggleClass("on");
            $("#menu").slideToggle();
        });
    
    }

    language = () => {
        this.lang.toggler.addEventListener('click', () => {
            this.lang.menu.classList.toggle('show');
        });
    }
}
